var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPlus = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 4.375C9.95312 4.375 10.125 4.45312 10.2656 4.60938C10.4219 4.75 10.5 4.92188 10.5 5.125V5.875C10.5 6.07812 10.4219 6.25781 10.2656 6.41406C10.125 6.55469 9.95312 6.625 9.75 6.625H6.375V10C6.375 10.2031 6.29688 10.375 6.14062 10.5156C6 10.6719 5.82812 10.75 5.625 10.75H4.875C4.67188 10.75 4.49219 10.6719 4.33594 10.5156C4.19531 10.375 4.125 10.2031 4.125 10V6.625H0.75C0.546875 6.625 0.367188 6.55469 0.210938 6.41406C0.0703125 6.25781 0 6.07812 0 5.875V5.125C0 4.92188 0.0703125 4.75 0.210938 4.60938C0.367188 4.45312 0.546875 4.375 0.75 4.375H4.125V1C4.125 0.796875 4.19531 0.625 4.33594 0.484375C4.49219 0.328125 4.67188 0.25 4.875 0.25H5.625C5.82812 0.25 6 0.328125 6.14062 0.484375C6.29688 0.625 6.375 0.796875 6.375 1V4.375H9.75Z",
    fill: "#8C8C8C"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/plus.b396fd2b.svg";
export { ForwardRef as ReactComponent };